import React from 'react';

export const PlantIcon = () => {
  // @ts-ignore
  return <iconify-icon class="Icon" icon="charm:plant-pot"></iconify-icon>;
};
